import script from './component-lib.esm2.js';
import normalizeComponent from '../../external/vue-runtime-helpers/dist/component-lib.esm.js';
import createInjector from '../../external/vue-runtime-helpers/dist/inject-style/component-lib.esm.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _vm.isEmbedLink ? _c('ProfileLinkWrapper', {
    on: {
      "event": _vm.handleEvent
    }
  }, [_c('div', {
    staticClass: "v-embed",
    class: _vm.classes,
    style: _vm.styles
  }, [_c('ProfileEmbedContainer', {
    attrs: {
      "is-open": "",
      "options": _vm.embedOptions,
      "embed-type": _vm.embedType,
      "id": _vm.embedId,
      "loader-color": _vm.loaderColor,
      "track-video-play-events": _vm.trackVideoPlayEvents,
      "lazy": ""
    },
    on: {
      "event": _vm.handleEvent
    }
  })], 1)]) : _vm._e();
};
var __vue_staticRenderFns__ = [];

/* style */
const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-7a7ed3c5_0", {
    source: ".v-embed[data-v-7a7ed3c5]{background:var(--c-bg-color);border:var(--p-btn-border-width) solid var(--p-btn-border-color);border-width:min(var(--p-btn-border-width),5px);border-radius:var(--p-btn-border-radius);border-radius:min(var(--p-btn-border-radius),10px);box-shadow:var(--p-btn-box-shadow);overflow:hidden}.v-embed--remove-bg[data-v-7a7ed3c5]{background:0 0;border:none;border-radius:0;box-shadow:none}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__ = "data-v-7a7ed3c5";
/* module identifier */
const __vue_module_identifier__ = undefined;
/* functional template */
const __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);
var ProfileEmbed = __vue_component__;
export { ProfileEmbed as default };